import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import { CompanyProfileOutput } from '@app/model/company_profile/output/CompanyProfileOutput';
import {
	DISABLE_COMPANY_PROFILE_MUTATION,
	FIND_COMPANY_PROFILES_QUERY,
	FIND_COMPANY_PROFILES_WITH_ACCESS_TO_COMPANY_HOTEL_QUERY,
	SAVE_COMPANY_PROFILE_MUTATION,
} from '@app/model/company_profile/service/CompanyProfileGraphQLQueries';
import CompanyProfileInput from '@app/model/company_profile/input/CompanyProfileInput';

export class CompanyProfileService {
	public static findCompanyProfilesWithAccessToCompanyHotel(companyHotelId: number) {
		return GraphQLExecutor.execute<CompanyProfileOutput[]>(FIND_COMPANY_PROFILES_WITH_ACCESS_TO_COMPANY_HOTEL_QUERY, { companyHotelId });
	}

	public static findCompanyProfiles() {
		return GraphQLExecutor.execute<CompanyProfileOutput[]>(FIND_COMPANY_PROFILES_QUERY);
	}

	public static saveCompanyProfile(input: CompanyProfileInput) {
		return GraphQLExecutor.execute<CompanyProfileOutput>(SAVE_COMPANY_PROFILE_MUTATION, { input });
	}

	public static disableCompanyProfile(disableProfileId: number) {
		return GraphQLExecutor.execute<CompanyProfileOutput>(DISABLE_COMPANY_PROFILE_MUTATION, { disableProfileId });
	}
}